import ENUM from '../ENUM'

export default function () {
    return {
        kind: 'CrossBreakSlide',
        filters: [
            {
                name: ENUM().comparisonSurveyIds,
            },
            {
                name: ENUM().benchmarks,
            },
            {
                name: 'questions',
            },
            {
                name: ENUM().ranking,
                // first item in array is the default
                options: [
                    {
                        label: ENUM().noRanking,
                        value: 'noRanking',
                        name: ENUM().ranking,
                    },
                    {
                        label: ENUM().lowToHigh,
                        value: 'lowToHigh',
                        name: ENUM().ranking,
                    },
                    {
                        label: ENUM().highToLow,
                        value: 'highToLow',
                        name: ENUM().ranking,
                    },
                    {
                        label: ENUM().aToZ,
                        value: 'aToZ',
                        name: ENUM().ranking,
                    },
                ],
            },
        ],
        references: [ENUM().kpiPageQuestionId],
    }
}
